import React, { useEffect, useState } from 'react';
import Logout from "../components/auth/Logout";
import Center from "../components/Center";
import { db } from "../config/firebase";
import { Link, useNavigate } from "react-router-dom";

import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import ViewAgendaOutlined from "@mui/icons-material/ViewAgendaOutlined";

import { Box, TextField, Button, Grid } from "@mui/material";


import {
  collection, 
  query,
  onSnapshot,
  doc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore';
import PlayerMatches from '../components/PlayerMatches';


const Home = () => {

  return (
    <PlayerMatches />
    
  )
}

export default Home